<template>
    <div class="cart-steps container" id="cart-steps">
        <Configure3DModelScaleSlider
            v-if="
                current3DFile &&
                    typeof currentCartItem.scale === 'number' &&
                    currentStep === 'configure'
            "
        ></Configure3DModelScaleSlider>
        <div class="cart-steps-container">
            <div
                class="cart-step"
                :class="{
                    'is-active': ['upload'].includes(currentStep),
                    'is-completed': ['configure', 'cart'].includes(currentStep),
                }"
            >
                <div class="cart-step-number">1.</div>
                <div>{{ $t('checkout.steps.choose3DFile') }}</div>
            </div>
            <div
                class="cart-step"
                :class="{
                    'is-active': ['configure'].includes(currentStep),
                    'is-completed': ['cart'].includes(currentStep),
                }"
            >
                <div class="cart-step-number">2.</div>
                <div>{{ $t('checkout.steps.choosePrintMode') }}</div>
            </div>
            <div
                class="cart-step"
                :class="{
                    'is-active': ['cart'].includes(currentStep),
                }"
            >
                <div class="cart-step-number">3.</div>
                <div>{{ $t('checkout.steps.checkout') }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import Configure3DModelScaleSlider from '../checkout/Configure3DModelScaleSlider';
import { mapGetters } from 'vuex';
import { orderProcess } from '../../store/constants/order-process';

export default {
    name: 'Steps',
    data() {
        return {
            orderProcess,
        };
    },
    components: {
        Configure3DModelScaleSlider,
    },
    computed: {
        ...mapGetters([
            'currentOrderProcessStep',
            'current3DFile',
            'currentCartItem',
        ]),
        currentStep() {
            if (
                [
                    orderProcess.STEPS.NO_ORDER_ONGOING,
                    orderProcess.STEPS.FILE_UPLOAD,
                    orderProcess.STEPS.ORDER_COMPLETED,
                ].includes(this.currentOrderProcessStep)
            ) {
                return 'upload';
            } else if (
                [orderProcess.STEPS.CONFIGURE_MODEL].includes(
                    this.currentOrderProcessStep
                )
            ) {
                return 'configure';
            } else {
                return 'cart';
            }
        },
    },
};
</script>

<style scoped></style>
